import { faAngleRight, faCheck, faPlus, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, FileButton, Grid, Group, Text, MultiSelect, Modal } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { IconUpload } from '@tabler/icons-react';
import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDebouncedValue } from '@mantine/hooks';
import { BASE_URL } from '../../api/EndPoints';
import { createB2BAPI } from '../../api/Interceptor';
import B2BPillsInput from '../../components/common/B2BPillsInput';
import B2BSelect from '../../components/common/B2BSelect';
import { ProductContext } from '../../Context/ProductContext';
import './ProductVariant.css';
import { Carousel } from '@mantine/carousel';
import B2BInput from '../../components/common/B2BInput';
import notify from '../../utils/Notification';
import { color } from '@mui/system';
import { Navigate, useNavigate } from 'react-router-dom';

const ProductVariant = ({ isReadOnly = false, tabInfo }) => {
    const ctx = useContext(ProductContext);
    const [swatchOpened, setSwatchOpened] = useState([]);
    if (!ctx) {
        console.error("⚠️ ProductContext not found! Make sure your component is wrapped in <ProductContext.Provider>.");
        return null;
    }
    const resetRef = useRef(null);
    const { product, handleChange, addProduct, setProduct, imageFile, setImageFile, inputError, setInputError, setHasMultiSelectCategoryMandatory, colourFile, setColourFile, swatchNotifyData: ctxSwatchNotifyData, setSwatchNotifyData: ctxSetSwatchNotifyData, validateProduct } = ctx;
    const navigate = useNavigate();
    const [attributes, setAttributes] = useState({});
    const [selectedPairs, setSelectedPairs] = useState([{ key: '', values: [] }]);
    const [combinations, setCombinations] = useState([]);
    const [variants, setVariants] = useState([]);
    const [activeTab, setActiveTab] = useState('Transaction');
    const [productVariantMap, setProductVariantMap] = useState(new Map())
    const [brand, setBrand] = useState([]);
    const initialData = { name: "", status: "ACTIVE", fromDate: "", toDate: "", seasonCode: "" }
    const [productTags, setProductTags] = useState([]);
    const [taxonomy, setTaxonomy] = useState([]);
    const [modalContent, setModalContent] = useState(initialData);
    const [activeComponent, setActiveComponent] = useState('');
    const [contentUpdated, setContentUpdated] = useState(false)
    const [season, setSeason] = useState([]);
    const [openSeason, setOpenSeason] = useState(false);
    const [selectedUOM, setSelectedUOM] = useState("Kg");
    const [mappedRib, setMappedRib] = useState([]);
    const [lastChild, setLastChild] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 500);
    const [imageFiles, setImageFiles] = useState([]); // multiple files
    const [imageError, setImageError] = useState(null);
    const [fabricContent, setFabricContent] = useState({});
    const [categorys, setCategorys] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [open, setOpen] = useState([]);
    const openRef = useRef(null);
    const isRowExpanded = (index) => expandedRows.includes(index);
    const [totalPercent, setTotalpercent] = useState(product?.totalProductPercent || 0);
    const [selectedPairsFabric, setSelectedPairsFabric] = useState([{ key: '', values: [], value: null }]);
    const B2B_API = createB2BAPI();
    const [existingPairs, setExistingPairs] = useState([]);
    const [existingPairsKeys, setExistingPairsKeys] = useState([]);

    useEffect(() => {
        const keyValuePairs = product.productVariants.map((productVariant) => {
            const filteredVariants = productVariant.variants
                .filter(variant => variant.name !== 'Solid / Pattern');
            return filteredVariants.map(variant => ({
                [variant.name]: variant.value
            }));
        })
            .reduce((acc, objArray) => {
                objArray.forEach(obj => {
                    const [key, value] = Object.entries(obj)[0];
                    if (acc[key]) {
                        acc[key] = [...new Set([...acc[key], value])];
                    } else {
                        acc[key] = [value];
                    }
                });
                return acc;
            }, {});
        setExistingPairs(keyValuePairs);
        const existingKeys = product.productVariants.map(productVariant => productVariant.variants.map(variant => variant.name)).flat();
        const uniqueKeys = [...new Set(existingKeys)];
        setExistingPairsKeys(uniqueKeys);
    }, [product.id]);

    useEffect(() => { fetchVariant(); }, []);
    useEffect(() => { generateProductVariantMap() }, [product?.productVariants])
    useEffect(() => { updateCombinations(selectedPairs); }, [variants, selectedPairs]);

    const generateCombinations = (lists, variants = []) => {
        const result = [];
        const generateCombinationsRecursive = (depth, current) => {
            if (depth === lists.length) {
                result.push([...current]);
                return;
            }
            for (const element of lists[depth]) {
                current.push(element);
                generateCombinationsRecursive(depth + 1, current);
                current.pop();
            }
        };
        generateCombinationsRecursive(0, []);
        return result;
    };

    const [activeSwatch, setActiveSwatch] = useState(null);
    const [localSwatchNotifyData, setLocalSwatchNotifyData] = useState({
        awbNumber: '',
        docNumber: '',
        courierName: '',
        swatchQuantity: '',
        dispatchDate: '',
        deliveryDate: '',
    });

    const swatchNotifyData = ctxSwatchNotifyData || localSwatchNotifyData;
    const setSwatchNotifyData = ctxSetSwatchNotifyData || setLocalSwatchNotifyData;




    const generateProductVariantMap = () => {
        if (product.productVariants && _.size(product.productVariants) > 0 && _.size(product.productVariants[0].variants) > 0) {
            const productMap = new Map();
            _.map(product.productVariants, pv => {
                const variantIds = _.map(pv.variants, va => va.id);
                const sortedVariantIds = _.sortBy(variantIds);
                productMap.set(JSON.stringify(sortedVariantIds), pv);
            });
            setProductVariantMap(productMap);
        }
    };

    const findMatchingVariant = (combination) => {
        for (let i = 0; i < combination.length; i++) {
            const partialCombination = _.slice(combination, 0, i + 1);
            const flattenedCombination = _.flatten(partialCombination);
            const sortedFlattenedCombination = _.sortBy(flattenedCombination);
            const key = JSON.stringify(sortedFlattenedCombination);
            if (productVariantMap.has(key)) {
                const variant = productVariantMap.get(key);
                productVariantMap.delete(key);
                return variant;
            }
        }
        return null;
    };

    const updateCombinations = async (pairs) => {
        const hasAnyKey = pairs && pairs.some(pair => Boolean(pair.key));
        const hasSelectedPairs = pairs && pairs.some(pair => pair.key && pair.values && pair.values.length > 0);
        if (!hasSelectedPairs) {
            if (hasAnyKey) {
                setCombinations([]);
                setProduct(prev => ({
                    ...prev,
                    newProductVariants: []
                }));
                return;
            }
            const existingVariants = (Array.isArray(product?.newProductVariants) && product.newProductVariants.length > 0)
                ? product.newProductVariants
                : (Array.isArray(product?.productVariants) && product.productVariants.length > 0)
                    ? product.productVariants
                    : [];
            setCombinations(existingVariants);
            if (existingVariants.length > 0) {
                setProduct(prev => ({
                    ...prev,
                    newProductVariants: (Array.isArray(prev.newProductVariants) && prev.newProductVariants.length > 0)
                        ? prev.newProductVariants
                        : existingVariants,
                }));
            }
            return;
        }

        const newCombinations = generateCombinations(pairs.map(pair => pair.values), variants);
        const prodVariants = [];
        setCombinations(newCombinations);
        _.forEach(newCombinations, combination => {
            let variant = findMatchingVariant(combination);
            if (variant === null) {
                variant = {}
            }
            variant['variants'] = _.map(combination, c => _.find(variants, v => v.id === c || v.variantId === c || v.value === c));
            variant['status'] = variant.id ? variant.status : 'ACTIVE'
            variant['name'] = `${product.articleName || "Product"} / ${getVarinatname(variant.variants)}`
            prodVariants.push(variant);
        });
        setProduct(prev => ({ ...prev, newProductVariants: prodVariants }));
        generateProductVariantMap();
    };

    const fetchVariant = async () => {
        try {
            const response = await B2B_API.get('variant').json();
            const groupedVariants = _.groupBy(response.response, 'name');
            setAttributes(groupedVariants);
            setVariants(response.response);
            setSelectedPairsFromProduct(response.response);
        } catch (error) {
            console.error('Error fetching variants:', error);
        }
    };

    const setSelectedPairsFromProduct = (masterVariantsList = variants) => {
        const prodVariants = {};

        const existingVariants = Array.isArray(product?.productVariants) && product.productVariants.length > 0
            ? product.productVariants
            : Array.isArray(product?.newProductVariants) && product.newProductVariants.length > 0
                ? product.newProductVariants
                : [];

        if (existingVariants.length > 0) {
            existingVariants.forEach(pv => {
                if (Array.isArray(pv.variants) && pv.variants.length > 0) {
                    pv.variants.forEach(v => {
                        if (v.name) {
                            if (!prodVariants[v.name]) {
                                prodVariants[v.name] = [];
                            }
                            const mv = masterVariantsList?.find(m => m.id === v.id || m.variantId === v.variantId || (v.variantId && m.id === v.variantId) || (v.id && m.variantId === v.id) || (m.name === v.name && m.value === v.value));
                            const targetId = mv ? mv.id : (v.id || v.variantId);
                            if (targetId && !prodVariants[v.name].includes(targetId)) {
                                prodVariants[v.name].push(targetId);
                            }
                        }
                    });
                } else if (pv.name && masterVariantsList && masterVariantsList.length > 0) {
                    let variantString = pv.name;
                    if (product.articleName && variantString.startsWith(product.articleName + " / ")) {
                        variantString = variantString.substring((product.articleName + " / ").length);
                    } else {
                        const parts = variantString.split(' / ');
                        if (parts.length > 1) {
                            variantString = parts.slice(1).join(' / ');
                        }
                    }
                    const nameParts = variantString.split(' / ').map(s => s.trim()).filter(Boolean);
                    masterVariantsList.forEach(mv => {
                        if (mv.name && mv.value && mv.id) {
                            if (nameParts.includes(mv.value) || variantString === mv.value) {
                                if (!prodVariants[mv.name]) {
                                    prodVariants[mv.name] = [];
                                }
                                if (!prodVariants[mv.name].includes(mv.id)) {
                                    prodVariants[mv.name].push(mv.id);
                                }
                            }
                        }
                    });
                }
            });
        }

        const keys = Object.keys(prodVariants);
        if (_.size(keys) > 0) {
            const pairs = keys.map(key => ({
                key,
                values: Array.from(new Set(prodVariants[key]))
            }));
            setSelectedPairs(pairs);
            setProduct(prev => ({
                ...prev,
                prodVariants: prodVariants,
            }));
        }
    };

    useEffect(() => {
        if (variants && variants.length > 0 && (product?.productVariants?.length > 0 || product?.newProductVariants?.length > 0)) {
            setSelectedPairsFromProduct(variants);
        }
    }, [product?.id, product?.productVariants, variants]);

    const handleSelectChange = (index, selectedValue) => {
        const newPairs = [...selectedPairs];
        const oldKey = newPairs[index].key;
        newPairs[index].key = selectedValue || '';
        if (!selectedValue) {
            newPairs[index].values = [];
        }
        const newKey = newPairs[index].key;
        if (newKey !== oldKey) {
            newPairs[index].key = selectedValue;
            newPairs[index].values = [];
        }
        setSelectedPairs(newPairs);
        const updatedProdVariants = { ...product.prodVariants };
        if (oldKey && oldKey !== selectedValue) {
            delete updatedProdVariants[oldKey];
        }
        if (selectedValue) {
            updatedProdVariants[selectedValue] = newPairs[index].values || [];
        }
        setProduct(prevState => ({ ...prevState, prodVariants: updatedProdVariants }));
        updateCombinations(newPairs);
    };

    const handleMultiSelectChange = (index, selectedValues) => {
        const newPairs = [...selectedPairs];
        newPairs[index].values = selectedValues;
        const updatedProdVariants = { ...product.prodVariants };
        updatedProdVariants[newPairs[index].key] = selectedValues;
        setSelectedPairs(newPairs);
        setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
        updateCombinations(newPairs);
    };

    const handleSelectSolidChange = (index, selectedValue) => {
        const newPairs = [...selectedPairs];
        newPairs[index].values = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
        const updatedProdVariants = { ...product.prodVariants };
        updatedProdVariants[newPairs[index].key] = newPairs[index].values;
        setSelectedPairs(newPairs);
        setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
        updateCombinations(newPairs);
    };

    const addNewPair = () => {
        const newPairs = [...selectedPairs, { key: '', values: [] }];
        setSelectedPairs(newPairs);
        const newCombinations = [{ ...selectedPairs[0], values: [] }, ...combinations];
        setCombinations(newCombinations);
        updateCombinations(newPairs);
    };

    const removePair = (index) => {
        const newPairs = [...selectedPairs];
        const removedPairKey = newPairs[index].key;
        newPairs.splice(index, 1);
        setSelectedPairs(newPairs);
        const updatedProdVariants = { ...product.prodVariants };
        delete updatedProdVariants[removedPairKey];
        setProduct(prev => ({ ...prev, prodVariants: updatedProdVariants }));
        updateCombinations(newPairs);
    };

    const getAvailableKeys = (currentIndex) => {
        const selectedKeys = selectedPairs.map(pair => pair.key);
        return Object.keys(attributes).filter(key => !selectedKeys.includes(key) || selectedPairs[currentIndex].key === key);
    };

    const handleToggle = (index) => {
        if (expandedRows.includes(index)) {
            setExpandedRows(expandedRows.filter((i) => i !== index));
        } else {
            setExpandedRows([index]);
        }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    const handleTransaction = (index, key, event) => {
        setProduct((prevProduct) => {
            return {
                ...prevProduct,
                newProductVariants: prevProduct.newProductVariants.map((variant, i) => {
                    if (i === index) {
                        return {
                            ...variant,
                            [key]: 'true' === event?.target?.value,
                        };
                    }
                    return { ...variant };
                }),
            };
        });
    };

    const json = [
        {
            label: 'USSID',
            value: product.vendorProductInfo?.ussId || product?.ussId || '',
            onChange: (event) => handleChange(event, 'vendorProductInfo.ussId', 'ussIdErrorMessage'),
            type: "text",
            fieldType: 'textField',
            require: true,
            disabled: true,
            placeholder: "  ",
            error: inputError?.ussIdError || '',
        },

        {
            fieldType: "checkbox",
            label: "Swatch Received",
            value: product?.swatchReceived ?? false,
            type: "checkbox",
            disabled: true,
            error: inputError?.swatchReceivedError,
        },
        {
            fieldType: "checkbox",
            label: "Swatch Sent",
            value: product?.swatchSent ?? false,
            onChange: () => {
                if (!product?.swatchSent) {
                    setActiveSwatch("sent");
                }
            },
            type: "checkbox",
            disabled: product?.swatchSent === true,
            error: inputError?.swatchSentError,
        },
    ];

    const handleEnable = (index) => {
        setProduct((prevProduct) => {
            return {
                ...prevProduct,
                newProductVariants: prevProduct.newProductVariants.map((variant, i) => {
                    if (i === index) {
                        return {
                            ...variant,
                            status: variant.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
                        };
                    }
                    return variant;
                }),
            };
        });
    };
    const handleSwatchSample = async () => {
        if (!activeSwatch) return;

        if (activeSwatch === "sent") {
            if (
                !swatchNotifyData.awbNumber?.trim() ||
                !swatchNotifyData.docNumber?.trim() ||
                !swatchNotifyData.courierName?.trim() ||
                !swatchNotifyData.swatchQuantity ||
                !swatchNotifyData.dispatchDate ||
                !swatchNotifyData.deliveryDate
            ) {
                notify({
                    error: true,
                    success: false,
                    title: "All fields are mandatory",
                });
                return;
            }

            const dispatch = new Date(swatchNotifyData.dispatchDate);
            const delivery = new Date(swatchNotifyData.deliveryDate);

            if (delivery < dispatch) {
                notify({
                    error: true,
                    success: false,
                    title: "Delivery Date should be after the Dispatch Date",
                });
                return;
            }
        }

        try {
            showLoader();
            let url = "";
            let successTitle = "";

            if (activeSwatch === "sent") {
                url = `draftProduct/updateSwatchSent?id=${product?.draftProductId}`;
                successTitle = "Swatch Sent successfully";

                const payload = {
                    draftProductId: product?.draftProductId,
                    ...swatchNotifyData,
                    swatchSent: true,
                    swatchRequest: true,
                    saveGe: false,
                };

                await B2B_API.post(`swatchNotifyData/create`, {
                    json: payload,
                }).json();
            } else if (activeSwatch === "received") {
                url = `draftProduct/updateSwatchReceived?id=${product?.draftProductId}`;
                successTitle = "Swatch marked as Received successfully";
            }

            if (url) {
                await B2B_API.get(url);
                setProduct((prev) => ({
                    ...prev,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        swatchSent: activeSwatch === "sent" ? true : prev.vendorProductInfo.swatchSent,
                        swatchReceived: activeSwatch === "received" ? true : prev.vendorProductInfo.swatchReceived,
                    },
                    swatchSent: activeSwatch === "sent" ? true : prev.swatchSent,
                    swatchReceived: activeSwatch === "received" ? true : prev.swatchReceived,
                }));

                notify({
                    error: false,
                    success: true,
                    title: successTitle,
                });
            }

            setActiveSwatch(null);
            navigate("/VendorHome", { state: { activeTab: 'Draft', tabinfo: 'Draft' } });
        } catch (error) {
            console.error("Error updating swatch:", error);

            notify({
                error: true,
                success: false,
                title: error?.message || "Something went wrong while updating swatch",
            });
        } finally {
            hideLoader();
        }
    };


    const getVarinatname = (variants) => {
        return variants.filter(v => v && v.value).map(v => v.value).join("/");
    }

    const fileChangee = (files) => {
        if (!files || files.length === 0) return;
        const validFiles = Array.from(files).filter((file) =>
            ["image/jpeg", "image/png"].includes(file.type)
        );
        if (validFiles.length === 0) {
            setImageError("Only PNG or JPEG files are allowed.");
            return;
        }
        setImageFile((prev) => [...(prev || []), ...validFiles]);
        setImageError(null);

        setInputError((prev) => ({
            ...prev,
            imageError: false,
            imageErrorMessage: ""
        }));
    };

    const clearFilee = () => {
        setImageFile([]);
        resetRef.current?.();
    };

    const existingImages = product?.vendorImages1 || (
        product?.vendorImages
            ?.filter((imgPath) => imgPath && imgPath.trim() !== "")
            .map((imgPath) => imgPath.startsWith("http") ? imgPath : `${BASE_URL}${imgPath.replace("/api", "")}`) || []
    );
    const newFiles = imageFile || [];
    const allImages = [...(existingImages || []), ...(newFiles || [])];

    const removeSingleFile = (index) => {
        if (index < existingImages.length) {
            setProduct(prev => ({
                ...prev,
                vendorImages: prev.vendorImages?.filter((_, i) => i !== index),
                vendorImages1: prev.vendorImages1?.filter((_, i) => i !== index),
            }));
        } else {
            const newIndex = index - existingImages.length;
            setImageFile((prev) => (prev || []).filter((_, i) => i !== newIndex));
        }
    };
    const newimage = product?.ussImages || [];

    return (
        <>
            <Modal
                opened={!!activeSwatch}
                title={
                    activeSwatch === "sent"
                        ? "Confirm Swatch Sent"
                        : "Confirm Swatch Received"
                }
                onClose={() => {
                    setActiveSwatch(null);
                    setSwatchNotifyData({
                        awbNumber: '',
                        docNumber: '',
                        courierName: '',
                        swatchQuantity: '',
                        dispatchDate: '',
                        deliveryDate: '',
                    });
                }}>
                <div>
                    {activeSwatch === "sent" && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "20px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>AWB Number <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter AWB Number"
                                    value={swatchNotifyData.awbNumber}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            awbNumber: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Doc Number <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Doc Number"
                                    value={swatchNotifyData.docNumber}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            docNumber: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Courier Name <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Courier Name"
                                    value={swatchNotifyData.courierName}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            courierName: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Swatch Qty <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Swatch Qty"
                                    value={swatchNotifyData.swatchQuantity}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            swatchQuantity: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Dispatch Date <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="date"
                                    value={swatchNotifyData.dispatchDate}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            dispatchDate: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Delivery Date <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="date"
                                    value={swatchNotifyData.deliveryDate}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            deliveryDate: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                        </div>
                    )}
                    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                        <Button
                            onClick={() => setActiveSwatch(null)}
                            style={{ backgroundColor: "red" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSwatchSample}
                            style={{ backgroundColor: "#8BC53F" }}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </Modal>

            <section className="product-variant-section pv-container">
                {/* Single-row form (horizontally scrollable on small screens) */}
                <div className="pv-form-row" role="form" aria-label="product-variant-form-row">
                    {json?.map((field, idx) => (
                        <div key={idx} className="pv-field-card">
                            <label className="pv-label">
                                {field.label}
                                {field.require && <span className="pv-required"> </span>}
                            </label>

                            {field.fieldType === 'textField' && (
                                <B2BInput
                                    value={field.value}
                                    className='input-textField pv-input'
                                    style={field.style}
                                    disabled={field.disabled}
                                    onChange={field.onChange}
                                    type={field.type}
                                    placeholder={field.placeholder}
                                    error={field.error}
                                />
                            )}

                            {field.fieldType === 'checkbox' && (
                                <Checkbox
                                    checked={field.value}
                                    onChange={field.onChange}
                                    disabled={field.disabled}
                                    color='#8BC53F'

                                />
                            )}

                            {field.fieldType === "selectField" && (
                                <div className="pv-select-wrap">
                                    <B2BSelect
                                        data={field.data || []}
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder={field.placeholder}
                                        clearable={field.clearable}
                                        error={field.error}
                                        maxDropdownHeight={400}
                                        className='input-textField pv-input'
                                    />
                                </div>
                            )}

                            {field.fieldType === 'multiselectField' && (
                                <div className="pv-select-wrap">
                                    <MultiSelect
                                        value={product?.tags || []}
                                        placeholder="Tags"
                                        styles={{
                                            input: { padding: '10px', width: '100%' },
                                        }}
                                        size='xs'
                                        data={productTags.map(tag => tag.name) || []}
                                        onChange={(selectedTags) => handleChange({ target: { value: selectedTags } }, "tags")}
                                    />
                                </div>
                            )}

                            {field.fieldType === 'textAreaField' && (
                                <textarea
                                    value={field.value}
                                    className='form-input-textarea'
                                    disabled={field.disabled}
                                    onChange={field.onChange}
                                    placeholder={field.placeholder}
                                />
                            )}

                            {field.error && <div className="field-error">{field.error}</div>}
                        </div>
                    ))}
                </div>

                <div className="pv-images-wrap">
                    <div className="pv-images-left">
                        {/* fixed-size box that always shows (placeholder when empty; carousel when images exist) */}
                        <div
                            className={`pv-carousel-box ${allImages.length === 0 ? 'pv-empty' : 'pv-has-images'}`}
                            aria-live="polite"
                        >
                            {allImages.length === 0 ? (
                                <div className="pv-empty-placeholder" role="status" aria-label="No images uploaded">
                                    <IconUpload size={20} />
                                    <div className="pv-empty-text">No images</div>
                                </div>
                            ) : (
                                <Carousel
                                    withIndicators
                                    height={180}
                                    slideSize="100%"
                                    align="start"
                                    withControls={allImages.length > 1}
                                    loop
                                    styles={{
                                        indicator: {
                                            width: 8,
                                            height: 8,
                                            backgroundColor: '#888',
                                        },
                                    }}
                                >
                                    {allImages.map((file, index) => (
                                        <Carousel.Slide key={index} className="pv-carousel-slide">
                                            <div className="pv-carousel-inner">
                                                <img
                                                    src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                                                    alt={`Uploaded-${index}`}
                                                />
                                                <Button
                                                    size="xs"
                                                    color="red"
                                                    className="pv-remove-btn"
                                                    onClick={() => removeSingleFile(index)}
                                                >
                                                    ✕
                                                </Button>
                                            </div>
                                        </Carousel.Slide>
                                    ))}
                                </Carousel>
                            )}
                        </div>

                        {/* Buttons stay below the fixed box; FileButton opens file dialog */}
                        <Group className="pv-btn-row">
                            <FileButton
                                resetRef={resetRef}
                                onChange={fileChangee}
                                accept="image/png,image/jpeg"
                                multiple
                            >
                                {(props) => (
                                    <Button
                                        {...props}
                                        style={{ backgroundColor: "#8BC53F", color: "white" }}
                                    >
                                        Add Images
                                    </Button>
                                )}
                            </FileButton>

                            <Button
                                disabled={!imageFile || imageFile.length === 0}
                                color="red"
                                onClick={clearFilee}
                            >
                                Reset All
                            </Button>
                        </Group>
                    </div>
                </div>
                {imageError &&
                    notify({
                        title: "Error!!",
                        message: imageError || "Failed to add Image.",
                        error: true,
                        success: false,
                    })}
                {inputError?.imageError && (
                    <Text size="xs" style={{ color: "red", marginTop: "6px" }}>
                        {inputError?.imageErrorMessage}
                    </Text>
                )}
            </section>

        </>

    );
};

export default ProductVariant;
